<template>
  <div class="filter-selections" :class="{'filter-selections--small': small}">
    <strong v-if="label" class="filters-selections__label">{{ label }}</strong>
    <span v-for="value in values" :key="value" class="filter-selections__value">{{ getValueText(value) }}</span>
  </div>
</template>

<script setup lang="ts">
import {formatText} from "@shared/utils/format-text";

const props = withDefaults(defineProps<{
  label: string | null;
  values: string[];
  small: boolean;
  formatValues?: boolean;
}>(), {
  formatValues: true,
});

const getValueText = (value: string): string => props.formatValues ? formatText(value) : value;
</script>
